import React from 'react';
import styles from "./PointIndication.module.scss";
export const PointIndication = () => /*#__PURE__*/React.createElement("div", {
  className: styles.root
}, /*#__PURE__*/React.createElement("div", {
  className: styles.point
}));